import { LyVariantChangedEventListener } from './base'

if (!customElements.get('ly-main-product-form-variant-picker-header-dimensions')) {
    customElements.define('ly-main-product-form-variant-picker-header-dimensions', class extends LyVariantChangedEventListener {

        _index = 0

        async connectedCallback() {
            super.connectedCallback()

            const script = this.querySelector('script[type="application/json"][data-dimensions]')
            this.dimensions = readJsonFromScript(script)

            await customElements.whenDefined('ly-popover-v5')
            this.popper = this.querySelector('ly-popover-v5')
            this.scroller = this.popper.bodyContent.querySelector('ly-full-scroll-carousel')

            this.popper.addEventListener('visibility_change', this.handleVisibleChange)

            this.update(Number(this.dataset.defaultVariantId))
        }

        disconnectedCallback() {
            this.popper.removeEventListener('visibility_change', this.handleVisibleChange)

            super.disconnectedCallback()
        }

        _onVariantChange = ({ variantId }) => {
            this.update(Number(variantId))

        }

        update = (variantId) => {
            if (!this.scroller || !this.dimensions) return
            const index = this.dimensions.findIndex(ids => {
                return ids.indexOf(variantId) !== -1
            })

            this._index = index
        }

        handleVisibleChange = (evt) => {
            if (evt.detail.visible) {
                requestAnimationFrame(() => {
                    this.scroller._index = this._index
                    this.scroller._updateStatus()
                })
            }
        }
    })
}